import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsappButton from "./components/WhatsappButton";

const AppContainer = styled.div`
  position: relative;
  min-height: 100vh;
  background: linear-gradient(
      135deg,
      #fff 0%,
      #f3f4f6 14%,
      #e0e2e6 32%,
      #bfc2c7 60%,
      #8d99ae 80%,
      #b28767 100%
    ),
    url("/logo-pattern.svg") center top repeat;
  background-size: cover, 400px auto;
  color: #23272f;
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  background: linear-gradient(
    180deg,
    #fff 0%,
    #f3f4f6 30%,
    #e0e2e6 60%,
    #bfc2c7 80%,
    #b28767 100%
  );
`;

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simular tempo de carregamento
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <AppContainer>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="loading-screen"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            flexDirection: "column",
            background: "rgba(255,255,255,0.9)",
          }}
        >
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            style={{
              width: "60px",
              height: "60px",
              border: "3px solid #adb5bd",
              borderTop: "3px solid transparent",
              borderRadius: "50%",
              marginBottom: "20px",
            }}
          />
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            style={{ color: "#495057", fontSize: "24px", fontWeight: "600" }}
          >
            PRISMA ORGANIZACIONAL
          </motion.h2>
        </motion.div>
      </AppContainer>
    );
  }

  return (
    <AppContainer>
      <ContentWrapper>
        <Header />
        <Hero />
        <Features />
        <About />
        <Services />
        <Contact />
        <Footer />
      </ContentWrapper>
      <WhatsappButton />
    </AppContainer>
  );
};

export default App;
